angular.module('cvsApp').service('unlockUserChallengeQuestionsService', ['networkService', 'xdrService', 'configManager', 
'unlockUserChallengeQuestionsServiceModel', 'cvsAppData', function (NS, XS, CM, USCQSM, CAD) {

    function unlockUserChallengeQuestions() {
        this.unlockUserChallengeQuestions = function (callBackSuccess, oUserInfo) {
            //get url
            // var tokenId = CAD.getTokenId();
            // var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var url = CM.getApiUrlWithApikey('UNLOCK_USER_CHALLENGE_QUESTIONS');
            if (url === "URL_ERROR") {

            } else {
                var plainUrl = CM.getPlainApiUrl(url);
                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: plainUrl,
                    header: {
                        'Content-Type': 'application/xml',
                        'accept': 'application/xml'
                    },
                    data: getRequestBody(oUserInfo),
                    onSuccess: callBackSuccess
                }
                    cvsUtility.commonServiceCode(plainUrl, "unlockUserChallengeQuestions", USCQSM, request, callBackSuccess, NS);
            }

        }

        var getRequestBody = function (oUserInfo) {
            
            var apikey = CAD.getApiKey();
            var x2js = new X2JS();
                var tokenType = CAD.getTokenType();
            return x2js.json2xml_str({
                "unlockUserChallengeQuestionsRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "channelName": cvsUtility.queryMap.channel,
                            "lineOfBusiness": "Specialty",
                                "responseFormat": "XML",
                                "tokenType": tokenType
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {
                        "firstName": oUserInfo.firstName,
                        "lastName": oUserInfo.lastName,
                        "emailAddress": oUserInfo.emailAddress,
                        "dateOfBirth": oUserInfo.dateOfBirth,
                    }
                }
            });

        }

    }

    return new unlockUserChallengeQuestions();
}]);